export default "data:image/gif;base64,R0lGODlhEgAMAPICAADNAP8AAP///wAAAOXl5QAAAAAAAAAAACH5BAAAAAAALAAAAAASAAwAAAMfSLrcLDDKKRS90eJLgP9gKI5kaZ5ioK5s675wLM9uAgA7"